// Languages list
export enum LANGUAGE {
    EN = 'en',
    UZ = 'uz',
    RU = 'ru',
}

// Mnemonic Language list object
export const languageList = {
    [LANGUAGE.EN]: 'English',
    [LANGUAGE.UZ]: 'O\'zbek',
    [LANGUAGE.RU]: 'Русский',
}

export const languageForUrl: Record<any, string> = {
    [LANGUAGE.EN]: 'ENG',
    [LANGUAGE.UZ]: 'UZB',
    [LANGUAGE.RU]: 'RUS',
}
